$(document).ready(function () {
    if ($(".fabricAction").length <= 0) {
        // cannot change fabric
        return;
    }

    cityDistrictLoader("city_name","İl Seçin",null,null);
    sessionStorage.removeItem("fabrics");
    sessionStorage.removeItem("prices");
    fabricSessionAdd(true);
    getSeriesInView();
    setComponentFabrics();

    $( ".search-fabric" ).keyup(function() {
        if($(this).val().length < 3){
            $( ".fabricPopupWrapper__popupInner__content_fabricBlock" ).show();
            $( ".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").show();
            return true;
        }
        searchFabric($(this).val());
    });

    $(document).on("click",".choose_fabric", function(){
        const moduleId = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-id");
        const sugarId = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-sugar-id");
        const fabricColourCode = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-code");
        const fabricColourId = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-id");
        const fabricColourImage = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-image");
        const fabricColourSeriesTitle = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-series-title");
        const fabricColourSeriesId = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-series-id");
        const fabricColourSeriesFinalPrice =  $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-series-final-price");
        const fabricColourRealColor =  $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr("data-module-colour-real-color");

        $(".fabricFooter").show();

        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info").remove();
        $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-fabric-colour-code="'+ fabricColourCode +'"]').append("<div class='fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info'>seçilen kumaş</div>");

        $('.fabricPopupWrapper__popupInner__footer').css('display', 'flex');

        setPrice(moduleId,fabricColourSeriesFinalPrice);
        var totalPrice = getTotalPrice();
        $(".fabricPopupWrapper__popupInner__footer_totalPrice_text").text("+"+ new Intl.NumberFormat('tr-TR').format(totalPrice) +" TL");

        var fabrics = JSON.parse(sessionStorage.getItem("fabrics"));

        var getFabric = '';
        fabrics.forEach(function(item) {
            if(item.module == moduleId){
                getFabric = item;
            }
        });

        if (getFabric){
            getFabric.selectedFabric = fabricColourCode;
            getFabric.selectedImg = fabricColourImage;
            getFabric.selectedSeriesTitle = fabricColourSeriesTitle;
            getFabric.selectedSeriesId = fabricColourSeriesId;
            getFabric.selectedColourId = fabricColourId;
            getFabric.selectedRealColor = fabricColourRealColor;
            sessionStorage.setItem("fabrics", JSON.stringify(fabrics));

            $( ".fabricPopupWrapper__popupInner__header_variants__productCard" ).each(function() {
                var thisModule = $(this).attr("data-module-id");
                if(thisModule === moduleId){
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr('data-module-colour-code', fabricColourCode);
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr('data-module-colour-series-id', fabricColourSeriesId);
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr('data-module-colour-id',fabricColourId);
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_title").text(fabricColourRealColor);
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('background-image', 'url(' + fabricColourImage + ')');
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('background-size', '100%');
                    $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('display', 'block');
                }
            });

            $(this).addClass('chosen');
            $(this).text('Seçildi');
            $(this).append('<i class="fa fa-check" style="font-size:16px; margin-left: 5%"aria-hidden="true"></i>');
            return fabrics;
        }
    });

    $(".fabricPopupWrapper__popupInner__footer_btn").mouseover(function() {
        $(this).css('cursor','pointer');
    });

    $(".fabricPopupWrapper__popupInner__footer_btn").on("click", function(){

        $(".fabricPopupWrapper__popupInner__header_variants__productCard, .product--active").removeClass("product--active");
        closeFabricPopup(".fabricPopupWrapper", "popup--show");
        $("body").removeClass("noAllowScroll");

        setWindowFabrics();

        setWindowPrice();

        if($('.chosen-fabric').attr("data-has-component") == 1){
            window.viveProductPage.calculateComponentPrice();
        }

        setComponentFabrics();

        removeChooseElements();
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel").removeClass("show--detail");
    });

    $(document).on("click",".fabricPopupWrapper__popupInner__header_variants__productCard", function(){
        $(".search-fabric").val("");
        searchFabric('');
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel").removeClass("show--detail");
        var thisModule = $(this).data("module-id");
        var sugarId = $(this).data("sugar-id");
        var modulePrice = $(this).data("module-colour-price");
        var thisDefaultColour = $(this).data("default-module-colour-code");

        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-id', thisModule);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-sugar-id', sugarId);
        $( ".header__selected" ).each(function() {
            $(this).removeClass("product--active");
            var thisDefaultColourSeriesId = $(this).data("default-module-colour-series-id");
            var clickModule = $(this).data("module-id");
            removeChooseElements();

            if(clickModule === thisModule){
                $(this).addClass("product--active");
                const meter = $(this).attr("data-module-meter");
                var manufacturerPrice = null;
                if(modulePrice > 0){
                    manufacturerPrice = modulePrice;
                }
                getSeriesPrices(meter,manufacturerPrice,thisDefaultColourSeriesId);
            }
        });

        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info").remove();
        var thisColourCode = $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr("data-module-colour-code");
        if(thisColourCode != thisDefaultColour){
            $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-fabric-colour-code="'+ thisColourCode +'"]').append("<div class='fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info'>seçilen kumaş</div>");
        }else{
            $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-fabric-colour-code="'+ thisColourCode +'"]').append("<div class='fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info'>görseldeki kumaş</div>");
        }
    });

    function closeFabricPopup(popupClass, toggleClass) {
        $(popupClass).removeClass(toggleClass);
    }

    function openFabricPopup (popupClass, toggleClass) {
        $(popupClass).addClass(toggleClass)
    }

    if($("#chosenFabric")){

        $(".chose_fabric").on("click", function () {
            var panelTopOffset = $("#chosenFabric").offset().top;
            $('html, body').animate({scrollTop:panelTopOffset - 80}, "slow");
            $("#chosenFabric").find(".panel-heading").addClass("open");
            $("#chosenFabric").find(".panel-body").show();
        });

    }

    $(".fabricPopupWrapper__popupInner_closeBtn").on("click", function () {
        closeFabricPopup(".fabricPopupWrapper", "popup--show");
        $("body").removeClass("noAllowScroll");
        setWindowFabrics();
        removeChooseElements();
        $("#form_product_component_fabric").attr('value', sessionStorage.getItem("fabrics"));
        if($('.chosen-fabric').attr("data-has-component") == 1){
            window.viveProductPage.calculateComponentPrice();
        }
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel").removeClass("show--detail");

        $('.fabricPopupWrapper__popupInner__footer').css('display', 'none');
    });

    $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_cls_btn").on("click", function () {
        closeFabricPopup(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel", "show--detail");
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").removeClass('active-fabric');
    });
    $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").on("click", function () {
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").removeClass('active-fabric');
        removeChooseElements();
        var panelInner = $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel");
        $(this).addClass("active-fabric");

        var thisItem = $(this),
            thisLine = thisItem.data("popup-key"),
            targetPanel = thisItem.nextAll(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel:eq(0)"),
            fabricTitle = thisItem.data("fabric-title"),
            sugarId = thisItem.data("sugar-id"),
            fabricTitleCode = thisItem.data("fabric-title-code"),
            fabricImg = thisItem.data("fabric-img"),
            fabricColourCode = thisItem.data("fabric-colour-code"),
            fabricColourId = thisItem.data("fabric-colour-id"),
            fabricSeriesTitle = thisItem.data("fabric-series-title"),
            fabricSeriesId = thisItem.data("series-id"),
            fabricSeriesFinalPrice = thisItem.data("price");
        var thisMod = thisLine % 11;
        thisMod = (thisMod == 0) ? 11 : thisMod;
        var meter = $("fabricPopupWrapper__popupInner__header_variants__productCard, .product--active").attr("data-module-meter");
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-code', fabricColourCode);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-id', fabricColourId);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-image', fabricImg);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-series-title', fabricSeriesTitle);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-series-id', fabricSeriesId);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-colour-real-color', fabricTitle);
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-sugar-id', sugarId);

        targetPanel.removeClass("line0n line1n line2n line3n line4n line5n line6n line7n line8n line9n line10n line11n line12n");
        targetPanel.addClass("line" + thisMod + "n");
        targetPanel.find(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_title").text(fabricTitle);
        targetPanel.find(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_code").text(fabricTitleCode);
        targetPanel.find(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_img img").attr("src", fabricImg);
        panelInner.removeClass("show--detail");
        targetPanel.addClass("show--detail");
        $(this).closest(".fabricPopupWrapper__popupInner__content_fabricBlock").animate({scrollTop: 60}, "slow");

    });

    $(".fabricAction a").on("click", function () {
        var chooseModule = $(this).closest(".fabricAction").attr("data-choose-module-id");
        var chooseValue = $(this).closest(".fabricAction").attr("data-choose-module-colour-code");
        var chooseMeter = $(this).closest(".fabricAction").attr("data-choose-module-meter");
        var choosePrice = $(this).closest(".fabricAction").attr("data-module-colour-price");
        var chooseColourSeriesId= $(this).closest(".fabricAction").attr("data-module-colour-series-id");

        openFabricPopup(".fabricPopupWrapper", "popup--show");
        $("body").addClass("noAllowScroll");
        var manufacturerPrice = null;
        if(choosePrice > 0){
            manufacturerPrice = choosePrice;
        }

        getSeriesPrices(chooseMeter,manufacturerPrice,chooseColourSeriesId);
        var variantCount = 0;
        $( ".fabricPopupWrapper__popupInner__header_variants__productCard" ).each(function() {
            $(this).removeClass("product--active");
            var thisModule = $(this).attr("data-module-id");
            var thisDefaultColour = $(this).attr("data-default-module-colour-code");
            if(thisModule === chooseModule){
                var leftValue = 150 * variantCount;
                $(".fabricPopupWrapper__popupInner .mCSB_container").css({left: leftValue});
                $(this).addClass("product--active");
                $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info").remove();
                var thisColourCode = $(this).children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric").attr("data-module-colour-code");
                if(thisColourCode != thisDefaultColour){
                    $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-fabric-colour-code="'+ thisColourCode +'"]').append("<div class='fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info'>seçilen kumaş</div>");
                }else{
                    $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-fabric-colour-code="'+ thisColourCode +'"]').append("<div class='fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric_info'>görseldeki kumaş</div>");
                }
            }
            variantCount = variantCount+1;
        });
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-id', chooseModule);
        var widthSize = JSON.parse(sessionStorage.getItem("fabrics")).length * 150;
        $("#mCSB_3_container").width(widthSize);

    });

    $(".fabricPopupAddressWrapper__popupInner_closeBtn").on("click", function () {
        closeFabricPopup(".fabricPopupAddressWrapper", "addressPopup--show");
        $("body").removeClass("noAllowScroll");
    });

    $(".fabricPopupCompleteWrapper__popupInner_closeBtn").on("click", function () {
        closeFabricPopup(".fabricPopupCompleteWrapper", "completePopup--show");
        $("body").removeClass("noAllowScroll");
    });

    $(".fabricEmailFormWrapper__popupInner__closeBtn").on("click", function () {
        closeFabricPopup(".fabricEmailFormWrapper", "emailPopup--show");
        $("body").removeClass("noAllowScroll");
    });

    $(".fabricPopupEmailSuccessWrapper__popupInner_closeBtn").on("click", function () {
        closeFabricPopup(".fabricPopupEmailSuccessWrapper", "emailSuccessPopup--show");
        $("body").removeClass("noAllowScroll");
    });

    $(".closeEmailForm").on("click", function () {
        closeFabricPopup(".fabricEmailFormWrapper", "emailPopup--show");
        $("body").removeClass("noAllowScroll");
    });

    $(".fabricFooter ").on("click", function () {

        openFabricPopup(".fabricPopupAddressWrapper", "addressPopup--show")
        $("body").addClass("noAllowScroll");
    });

    $(".view3DAction ").on("click", function () {

        openFabricPopup(".fabricPopupWrapper", "popup--show");
        $("body").addClass("noAllowScroll");
    });

    $(".fabricDeleteBtn").on("click", function () {
        var chooseModule = $(this).attr("data-choose-module-id");
        $('.fabricInfo[data-default-module-id="'+ chooseModule +'"]').css('display','');
        $('.fabricInfo[data-module-id="'+ chooseModule +'"]').css('display','none');
        $('.fabricInfo[data-module-id="'+ chooseModule +'"]').css('display','none');
        var defaultColour = $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ chooseModule +'"]').attr("data-default-module-colour-code");
        var defaultColourId = $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ chooseModule +'"]').attr("data-default-module-colour-id");
        var defaultImage = $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ chooseModule +'"]').attr("data-default-module-colour-image");
        var defaultSeriesId = $('.fabricPopupWrapper__popupInner__header_variants__productCard[data-module-id="'+ chooseModule +'"]').attr("data-default-module-colour-series-id");
        $('.selected--module[data-module-id="'+ chooseModule +'"]').attr('data-module-colour-code', defaultColour);
        $('.selected--module[data-module-id="'+ chooseModule +'"]').attr('data-module-colour-id', defaultColourId);
        $('.selected--module[data-module-id="'+ chooseModule +'"]').attr('data-module-colour-series-id', defaultSeriesId);
        $('.selected--module[data-module-id="'+ chooseModule +'"]').attr('data-module-colour-image', defaultImage);
        if(defaultColourId == 0){
            $('.selected--module[data-module-id="'+ chooseModule +'"]').children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('display', 'none');
        }
        $('.selected--module[data-module-id="'+ chooseModule +'"]').children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('background-image', 'url(' + defaultImage + ')');
        $('.selected--module[data-module-id="'+ chooseModule +'"]').children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_color").css('background-size', '100%');
        $('.selected--module[data-module-id="'+ chooseModule +'"]').children(".fabricPopupWrapper__popupInner__header_variants__productCard__fabric_title").text(defaultColour);

        fabricSessionRemoveByModule(chooseModule);
        fabricSessionAdd(false);
        $("#form_product_component_fabric").attr('value', sessionStorage.getItem("fabrics"));

        if($('.chosen-fabric').attr("data-has-component") == 1){
            window.viveProductPage.calculateComponentPrice();
        }

        if ($(".fabricFooter").data("visible") != 1 && !isAnyFabricSelected() ) {
            $(".fabricFooter").hide();
        }
    });

    if ($(".fabricFooter").data("visible") == 1) {
        $(".fabricFooter").show();
    }

    $(".fabricPopupWrapper__popupInner__header_variants").mCustomScrollbar({
        axis:"x"
    });

    function isAnyFabricSelected() {
        var isFabricSelected = false;
        $(".selected--module").each(function () {
            if ($(this).attr("data-module-colour-id") != "0") {
                isFabricSelected = true;
                return false;
            }
        });

        return isFabricSelected;
    }


});

function fabricSessionAdd(hasSetPrice){
    $( ".selected--module" ).each(function() {
        var thisTopModule = $(this).attr("data-top-module-id");
        var thisTop = $(this).attr("data-top-module");
        var thisModule = $(this).attr("data-module-id");
        var thisValue = $(this).attr("data-module-colour-code");
        var thisImg = $(this).attr("data-module-colour-image");
        var thisSeriesTitle = $(this).attr("data-module-colour-series-title");
        var thisSeriesId = $(this).attr("data-module-colour-series-id");
        var thisColourId = $(this).attr("data-module-colour-id");
        var thisRealColor = $(this).attr("data-module-colour-real-color");

        var moduleObject = {
            topModule : thisTopModule,
            module : thisModule,
            topModuleId : thisTop,
            selectedFabric : thisValue,
            selectedImg : thisImg,
            selectedSeriesTitle : thisSeriesTitle,
            selectedSeriesId : thisSeriesId,
            selectedColourId : thisColourId,
            selectedRealColor:thisRealColor
        }

        var fabrics = JSON.parse(sessionStorage.getItem("fabrics"));

        if (!fabrics){
            fabrics = []
        }else{
            var getFabric = '';
            fabrics.forEach(function(item) {
                if(item.module == thisModule){
                    getFabric = item;
                }
            });
            if(getFabric){
                moduleObject.selectedFabric = thisValue;
                moduleObject.selectedImg = thisImg;
                moduleObject.selectedSeriesTitle = thisSeriesTitle;
                moduleObject.selectedSeriesId = thisSeriesId;
                moduleObject.selectedColourId = thisColourId;
                moduleObject.selectedRealColor = thisRealColor;
                sessionStorage.setItem("fabrics", JSON.stringify(fabrics));
                return fabrics;
            }
        }

        fabrics.push(moduleObject);
        sessionStorage.setItem("fabrics", JSON.stringify(fabrics))
        return fabrics;
    });

    if(hasSetPrice){
        $( ".fabricPopupWrapper__popupInner__header_variants__productCard__fabric" ).each(function() {
            var thisModule = $(this).attr("data-module-id");
            setPrice(thisModule,0);
        });
    }
}

function fabricSessionRemove(moduleId, topModuleId){
    var fabrics = JSON.parse(sessionStorage.getItem("fabrics"));

    if (!fabrics){
        fabrics = []
    }else{
        jQuery.each( fabrics, function( index, val ) {
            if(topModuleId != null && val.topModuleId == topModuleId){
                var modules = val.module;
                setPrice(modules,0);
                fabrics = jQuery.grep(fabrics, function(value) {
                    return value != val;
                });
            }else if(val.topModule == moduleId){
                var modules = val.module;
                setPrice(modules,0);
                fabrics = jQuery.grep(fabrics, function(value) {
                    return value != val;
                });
            }
        });
        setValueHiddenProductComponentFabric();
    }
    sessionStorage.setItem("fabrics", JSON.stringify(fabrics));

    return fabrics;
}

function fabricSessionRemoveByModule(moduleId){
    var fabrics = JSON.parse(sessionStorage.getItem("fabrics"));

    if (!fabrics){
        fabrics = []
    }else{
        jQuery.each( fabrics, function( index, val ) {
            if(val.module == moduleId){
                var modules = val.module;
                setPrice(modules,0);
                fabrics = jQuery.grep(fabrics, function(value) {
                    return value != val;
                });
            }
        });
        setValueHiddenProductComponentFabric();
    }
    sessionStorage.setItem("fabrics", JSON.stringify(fabrics));
    $("#form_product_component_fabric").attr('value', sessionStorage.getItem("fabrics"));
    return fabrics;
}

function removeChooseElements(){
    $(".choose_fabric, .chosen").children("i").remove();
    $(".choose_fabric, .chosen").text('Kumaşı Seç');
    $(".choose_fabric, .chosen").removeClass("chosen");
}

function getSeriesPrices(meter,manufacturerPrice,thisDefaultColourSeriesId){
    $( ".fabricPopupWrapper__popupInner__content_fabricBlock_header_fabricPrice").each(function() {
        var price = $(this).attr("data-series-price");

        var moduleFabricPrice = Math.round(meter*price);

        var seriesId = $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_header").parent(".fabricPopupWrapper__popupInner__content_fabricBlock").attr("data-series-id");

        if(thisDefaultColourSeriesId == seriesId){
            moduleFabricPrice = 0;
        }
        $(this).children(".fabricPopupWrapper__popupInner__content_fabricBlock_header_fabricPrice_text").text("+"+ new Intl.NumberFormat('tr-TR').format(moduleFabricPrice) +" TL")
        $(this).parent(".fabricPopupWrapper__popupInner__content_fabricBlock_header")
            .parent(".fabricPopupWrapper__popupInner__content_fabricBlock")
            .children(".fabricPopupWrapper__popupInner__content_fabricBlock_content")
            .children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel")
            .children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info")
            .children(".fabricPopupWrapper__detailPanel_info")
            .children(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel_info_btn").attr('data-module-series-final-price', moduleFabricPrice);
    });
}

function setDefaultPrice() {
    var prices = JSON.parse(sessionStorage.getItem("prices"));
    prices.forEach(function(item) {
        item.price = 0;
        sessionStorage.setItem("prices", JSON.stringify(prices));
    });
    setWindowPrice();
    removeChooseElements();
}

function setPrice(moduleId, newPrice){
    var moduleObject = {
        module : moduleId,
        price : 0
    }

    var prices = JSON.parse(sessionStorage.getItem("prices"));
    if (!prices){
        prices = []
    }else{
        var getPrice = '';
        prices.forEach(function(item) {
            if(item.module == moduleId){
                getPrice = item;
            }
        });
        if(getPrice){
            getPrice.price = newPrice;
            sessionStorage.setItem("prices", JSON.stringify(prices));
            setWindowPrice();
            return prices;
        }
    }

    prices.push(moduleObject);
    sessionStorage.setItem("prices", JSON.stringify(prices));
    setWindowPrice();
    return prices;
}

function getTotalPrice() {
    var prices = JSON.parse(sessionStorage.getItem("prices"));
    var totalPrice = 0;
    prices.forEach(function(item) {
        totalPrice = Number(totalPrice) + Number(item.price);
    });

    return totalPrice;
}

function setComponentFabrics(){
    var fabrics = sessionStorage.getItem("fabrics");
    $("#form_product_component_fabric").attr('value', fabrics);
}

function setWindowPrice() {
    var totalPrice = getTotalPrice();

    $(".fabricTotalPrice_text").text("+"+ new Intl.NumberFormat('tr-TR').format(totalPrice) +" TL");

    $(".component-fabric").hide();
    if(totalPrice != 0){
        $(".component-fabric").show();
    }

    $(".component-price-fabric").text("+"+ new Intl.NumberFormat('tr-TR').format(totalPrice) +" TL");
    $(".component-price-fabric").attr('data-cart-fabric-price', totalPrice);
    $(".fabricPopupWrapper__popupInner__footer_totalPrice_text").text("+"+ new Intl.NumberFormat('tr-TR').format(totalPrice) +" TL");
}

function setValueHiddenProductComponentFabric() {
    if($("#form_product_component_fabric").val() == ''){
        return false;
    }
    $("#form_product_component_fabric").attr('value', sessionStorage.getItem("fabrics"));
    return true;
}

function setWindowFabrics() {
    var fabrics = JSON.parse(sessionStorage.getItem("fabrics"));
    $( ".defaultFabric" ).each(function() {
        const moduleId = $(this).attr("data-default-module-id");
        const fabricCode = $(this).attr("data-default-colour-code");
        var getFabric = '';
        fabrics.forEach(function(item) {
            if(item.module == moduleId){
                getFabric = item;
            }
        });

        if(getFabric && getFabric.selectedFabric !== fabricCode){
            $(this).css('display','none');
            $('.changedFabric[data-module-id="'+ moduleId +'"]').css('display','');
            $('.changedFabric[data-module-id="'+ moduleId +'"]').children(".fabricPreview").css('background-image', 'url(' + getFabric.selectedImg + ')');
            $('.changedFabric[data-module-id="'+ moduleId +'"]').children(".fabricPreview").css('background-size', '100%');;
            $('.changedFabric[data-module-id="'+ moduleId +'"]').children(".fabricRealColor").text(getFabric.selectedRealColor);
            $('.changedFabric[data-module-id="'+ moduleId +'"]').children(".fabricGroupName").text(getFabric.selectedSeriesTitle);

        }
    });
}

function getSeriesInView(){
    sessionStorage.removeItem("fabricSearch");
    $( ".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric" ).each(function() {
        var thisFabric = $(this).attr("data-fabric-colour-code");
        var thisValue = $(this).attr("data-series-id");
        var thisType = $(this).attr("data-line");
        fabricSeriesSessionAdd(thisFabric,thisValue,thisType);
    });

    $( ".fabricPopupWrapper__popupInner__content_fabricBlock" ).each(function() {
        var thisFabric = $(this).attr("data-series-title");
        var thisValue = $(this).attr("data-series-id");
        var thisType = 'block';
        fabricSeriesSessionAdd(thisFabric,thisValue,thisType);
    });
}

function fabricSeriesSessionAdd(thisFabric, thisValue, thisType) {
    var moduleObject = {
        title : thisFabric,
        id : thisValue,
        type : thisType,
    }

    var fabrics = JSON.parse(sessionStorage.getItem("fabricSearch"));

    if (!fabrics){
        fabrics = []
    }else{
        var getFabric = '';
        fabrics.forEach(function(item) {
            if(item.title == thisFabric){
                getFabric = item;
            }
        });
        if(getFabric){
            moduleObject.id = thisValue;
            moduleObject.title = thisFabric;
            moduleObject.type = thisType;
            sessionStorage.setItem("fabricSearch", JSON.stringify(fabrics));
            return fabrics;
        }
    }

    fabrics.push(moduleObject);
    sessionStorage.setItem("fabricSearch", JSON.stringify(fabrics))
    return fabrics;
}

function searchFabric($key)
{
    var result = filterItems($key,JSON.parse(sessionStorage.getItem("fabricSearch")));
    if(result){
        $( ".fabricPopupWrapper__popupInner__content_fabricBlock" ).hide();
        $( ".fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric").hide();
        $(".fabricPopupWrapper__popupInner__content_fabricBlock_content_detailPanel").removeClass("show--detail");
        result.forEach(function(item) {
            $('.fabricPopupWrapper__popupInner__content_fabricBlock[data-series-id="'+ item.id +'"]').show();
            if(item.type != 'block'){
                $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-line="'+ item.type +'"]').show();
            }else{
                $('.fabricPopupWrapper__popupInner__content_fabricBlock_content_fabric[data-series-id="'+ item.id +'"]').show();
            }

        });
    }
}

function filterItems(search, fabricList) {
    var query = search.toLowerCase();
    return fabricList.filter(function(item) {
        return item.title.toLowerCase().indexOf(query) >= 0;
    })
}

$("#fabric_form").on('submit', function(e){
    e.preventDefault();

    var formData = $(this).serializeArray();

    var productName = window.product.name + " (" + window.product.sku + ")";
    var productImg = $("meta[property='og:image']").attr('content');

    var selectedFabricsArray = getSelectedFabrics();

    $('#fabricFormSubmit').html('<i class="fa fa-spinner fa-spin" style="font-size:24px"></i>').attr('disabled', 'disabled');

    formData.push({name: 'fabrics', value: selectedFabricsArray.toString() });
    formData.push({name: 'productImg', value: productImg});
    formData.push({name: 'productName', value: productName});

    $.ajax('/ajax/fabric/fabricRegister.php', {
        method: 'POST',
        data: formData
    }).done(function (responseData) {

        var response = JSON.parse(responseData);

        if (response.error && response.msg != '') {
            $.jAlert({
                'title': '&nbsp;',
                'content': '<span>' + response.msg + '</span>',
                'theme': 'default',
                'size': 'sm',
                'showAnimation': 'fadeIn',
                'hideAnimation': 'fadeOut',
                'btns': [{'text': 'TAMAM', 'id': 'cancel-id'}]
            });

        } else {
            $(".fabricPopupCompleteWrapper").addClass("completePopup--show");
        }
        $(".fabricPopupAddressWrapper__popupInner_closeBtn").click();
        $('#fabricFormSubmit').html('ADRESİME GÖNDER').removeAttr('disabled');

    }).fail(
        function() {
            $(".fabricPopupAddressWrapper__popupInner_closeBtn").click();
            $.jAlert({
                'title': '&nbsp;',
                'content': '<span>Kartela talebin alınamadı. Lütfen sayfayı yenileyip tekrar deneyiniz.</span>',
                'theme': 'default',
                'size': 'sm',
                'showAnimation': 'fadeIn',
                'hideAnimation': 'fadeOut',
                'btns':  [ {'text': 'TAMAM','id':'cancel-id'}]
            });
        }
    );

});

$('#city_name').on('change',function(){
    var select = $('#neighbourhood');
    $('option', select).remove();
    var option = new Option("Mahalle Seçin", "");
    select.append($(option));
    cityDistrictLoader("district","İlçe Seçin",$(this).find(':selected').data('id'),"county");
});

$('#district').on('change',function(){
    cityDistrictLoader("neighbourhood","Mahalle Seçin",$(this).find(':selected').data('id'),"district");
});

$('#neighbourhood').on('change',function(){
    $('#zipCode').val( $(this).find(':selected').data('zipcode'));
});


function cityDistrictLoader( combobox_id, option_text ,id, type) {

    $.ajax('/ajax/management/cityDistrictLoader.php?type=' + type + '&id=' + id, {
        method: 'GET',
        // DO NOT USE async false UNLESS REALLY REALLY NECESSARY
        // async:false,
        fail: function(){

            return false;
        },
    }).done(function (response) {
        if (response.status) {
            var select = $('#' + combobox_id);

            $('option', select).remove();
            var option = new Option(option_text, "");
            select.append($(option));

            $.each(response.body, function (key,val) {
                var option =  $('<option>').val(key).attr('data-id',val.id).text(key);
                if(type === "district"){
                    option.attr('data-zipcode',val.zipCode);
                }
                option.appendTo(select);
            });
        } else {

            return false;
        }
    });
    return false;
}

function getSelectedFabrics() {
    var defaultColorCode = "Görseldeki Gibi";

    var selectedFabricsArray = [];

    $('.selected--module').each(function () {
        var moduleColorCode = $(this).data("module-colour-code");

        if (moduleColorCode !== defaultColorCode) {
            selectedFabricsArray.push(moduleColorCode);
        }
    });

    return selectedFabricsArray;
}
